module.exports = __webpack_public_path__ + "static/media/DSC_0212 (2).9b712804.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0212 (2).jpg
// module id = 647
// module chunks = 0